export const templates = {
  HorizontalEpg: 'HorizontalEpg',
};

export const PIXELS_PER_MINUTE = 6;

export const START_HOUR = 6;

export const FOCUS_MODE_NAV = 'navigation';

export const FOCUS_MODE_GRID = 'grid';

export const MORNING_HOUR = 6;

export const AFTERNOON_HOUR = 13;

export const EVENING_HOUR = 19;

export const TODAY_I18N_KEY = 'epgGrid.today';

export const DAYS_OF_THE_WEEK_I18N = [
  'date.days.sunday',
  'date.days.monday',
  'date.days.tuesday',
  'date.days.wednesday',
  'date.days.thursday',
  'date.days.friday',
  'date.days.saturday',
];
export const MONTHS_I18N_KEY = [
  'date.months.january',
  'date.months.february',
  'date.months.march',
  'date.months.april',
  'date.months.may',
  'date.months.june',
  'date.months.july',
  'date.months.august',
  'date.months.september',
  'date.months.october',
  'date.months.november',
  'date.months.december',
];

export const ABBREVIATION_I18N_KEY = 'abbreviation';

export const COMPLETE_I18N_KEY = 'complete';
